import type { SxProps, Theme } from "@mui/material/styles";

import { elevatedSurfaceShadow, primaryAccentColor } from "@/src/theme/helpers";

export const getContainerStyles = (muiTheme: Theme) => ({
  position: "fixed" as const,
  top: { xs: "72px", sm: "80px" },
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 1100,
  minWidth: { xs: "calc(100% - 32px)", sm: "420px" },
  maxWidth: "540px",
  backgroundColor: muiTheme.palette.background.paper,
  border: `1px solid ${muiTheme.palette.semantic.primary.main}`,
  borderRadius: 3,
  boxShadow: elevatedSurfaceShadow(muiTheme),
  padding: { xs: 2.5, sm: 3 },
  transition: "all 0.3s ease-in-out"
});

export const CONTENT_BOX_STYLE = {
  display: "flex",
  flexDirection: "column",
  gap: 2
} as const;

export const HEADER_BOX_STYLE = {
  display: "flex",
  alignItems: "flex-start",
  gap: 2
} as const;

export const getProgressColor = (muiTheme: Theme) => ({
  color: primaryAccentColor(muiTheme),
  flexShrink: 0,
  width: "24px",
  height: "24px"
});

export const TITLE_STYLE: SxProps<Theme> = (muiTheme) => ({
  fontWeight: muiTheme.typography.fontWeightMedium,
  color: muiTheme.palette.text.primary,
  fontSize: {
    xs: muiTheme.typography.buttonLarge.fontSize,
    sm: muiTheme.typography.body1.fontSize
  },
  lineHeight: 1.4,
  textTransform: "none"
});

export const SIZE_TEXT_STYLE: SxProps<Theme> = (muiTheme) => ({
  fontSize: {
    xs: muiTheme.typography.caption.fontSize,
    sm: muiTheme.typography.buttonSmall.fontSize
  },
  color: muiTheme.palette.text.secondary,
  marginTop: 0.5,
  fontWeight: muiTheme.typography.fontWeightRegular
});

export const WARNING_BOX_STYLE: SxProps<Theme> = (muiTheme) => ({
  display: "flex",
  alignItems: "center",
  gap: 1,
  padding: 1.25,
  backgroundColor: muiTheme.palette.misc.coldBackground,
  borderRadius: 2,
  border: "1px solid",
  borderColor: muiTheme.palette.divider
});

export const WARNING_ICON_STYLE: SxProps<Theme> = (muiTheme) => ({
  color: muiTheme.palette.text.secondary,
  fontSize: muiTheme.typography.h4.fontSize,
  flexShrink: 0
});

export const WARNING_TEXT_STYLE: SxProps<Theme> = (muiTheme) => ({
  color: muiTheme.palette.text.primary,
  fontSize: {
    xs: muiTheme.typography.caption.fontSize,
    sm: muiTheme.typography.buttonSmall.fontSize
  },
  lineHeight: 1.5,
  fontWeight: muiTheme.typography.fontWeightRegular
});
